import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'
import { getters } from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    plugins: [createPersistedState({ storage: window.sessionStorage })],
    state,
    mutations,
    actions,
    getters
})

export default store